<hlm-sidebar-wrapper class="dashboard-shell">
  <hlm-sidebar class="dashboard-sidebar border-r-0">
    <div hlmSidebarHeader class="p-5">
      <a routerLink="/" class="flex items-center gap-3">
        <span class="brand-logo-frame size-12 shrink-0 overflow-hidden rounded-full">
          <img src="/assets/icon/ancLogo.jpeg" alt="All Nigeria Community Ghana" class="size-full object-cover" />
        </span>
        <span class="min-w-0">
          <strong class="block truncate font-heading text-sm font-bold">ANC Ghana</strong>
          <small class="block truncate text-[10px] font-bold uppercase tracking-[0.18em] text-gold">Member portal</small>
        </span>
      </a>
    </div>

    <div class="px-5 py-2">
      <div class="member-access-card rounded-xl p-3">
        <div class="flex items-center gap-2">
          <ng-icon name="lucideShieldCheck" />
          <span class="text-xs font-semibold">Secure member access</span>
        </div>
      </div>
    </div>

    <div hlmSidebarContent>
      <div hlmSidebarGroup>
        <div hlmSidebarGroupLabel class="nav-label">Dashboard</div>
        <div hlmSidebarGroupContent>
          <ul hlmSidebarMenu>
            <li hlmSidebarMenuItem>
              <a hlmSidebarMenuButton routerLink="/dashboard/membership-form" routerLinkActive #overview="routerLinkActive" [isActive]="overview.isActive" class="w-full justify-start gap-3">
                <ng-icon name="lucideLayoutDashboard" />
                <span>Overview</span>
              </a>
            </li>
            <li hlmSidebarMenuItem>
              <a hlmSidebarMenuButton routerLink="/dashboard/my-application-form" routerLinkActive #application="routerLinkActive" [isActive]="application.isActive" class="w-full justify-start gap-3">
                <ng-icon name="lucideFileText" />
                <span>My application</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div hlmSidebarFooter class="dashboard-sidebar-footer p-4">
      <hlm-alert-dialog>
        <button hlmSidebarMenuButton hlmAlertDialogTrigger class="w-full justify-start gap-3 text-destructive hover:text-destructive hover:bg-destructive/10">
          <ng-icon name="lucideLogOut" />
          <span>Logout</span>
        </button>
        <hlm-alert-dialog-content *brnAlertDialogContent="let ctx">
          <hlm-alert-dialog-header>
            <h3 hlmAlertDialogTitle>Log out of your account?</h3>
            <p hlmAlertDialogDescription>
              This will log you out of your account and you will need to sign in again to access your dashboard.
            </p>
          </hlm-alert-dialog-header>
          <hlm-alert-dialog-footer>
            <button hlmAlertDialogCancel (click)="ctx.close()">Cancel</button>
            <button hlmAlertDialogAction (click)="logout()">Log out</button>
          </hlm-alert-dialog-footer>
        </hlm-alert-dialog-content>
      </hlm-alert-dialog>
    </div>
  </hlm-sidebar>

  <main hlmSidebarInset class="dashboard-main flex grow min-h-screen flex-col">
    <div class="brand-gradient-bar h-1.5 shrink-0"></div>
    <header class="dashboard-header flex h-20 shrink-0 items-center gap-3 border-b px-4 sm:px-6">
      <button hlmSidebarTrigger class="-ml-1"></button>
      <brn-separator hlmSeparator orientation="vertical" class="h-5"></brn-separator>
      <div class="min-w-0 flex-1">
        <p class="text-xs font-bold uppercase tracking-[0.16em] text-primary">Membership portal</p>
        <h1 class="truncate font-heading text-lg font-bold text-foreground sm:text-xl">My dashboard</h1>
      </div>
      <span hlmBadge variant="outline" class="hidden sm:inline-flex">
        <ng-icon name="lucideShieldCheck" />
        Secure session
      </span>
    </header>

    <div class="dashboard-content flex-1">
      <router-outlet></router-outlet>
    </div>

    <app-footer />
  </main>
</hlm-sidebar-wrapper>
